module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/Rice/Nagano_Rice_MRI_RCP45_End.png";